export interface IIconList {
    [s: string]: Record<string, string>
}

export const iconList = {
    'font-awesome': {
        human: 'fas fa-male',
        clipboard: 'far fa-clipboard',
        multigadget: 'far fa-cogs',
        wrench: 'far fa-wrench',
        trafficCone: 'fas fa-traffic-cone',
        pallet: 'fas fa-pallet-alt',
        userHardHat: 'far fa-user-hard-hat',
        usersClass: 'fas fa-users-class',
        users: 'fas fa-users',
        file: 'far fa-file-alt',
        fileCertificate: 'far fa-file-certificate',
        mapSigns: 'far fa-map-signs',
        industry: 'far fa-industry',
        truck: 'far fa-truck',
        broadcastTower: 'far fa-broadcast-tower',
        shieldCheck: 'far fa-shield-check',
        bolt: 'fas fa-bolt',
        sunDust: 'fas fa-sun-dust',
        square: 'far fa-square',
        triangle: 'far fa-triangle',
        circle: 'far fa-circle'
    }
}
